<template>
	<div class="item">
		<div class="image" v-if="imageUrl">
			<div class="img" :style="{backgroundImage: `url('${imageUrl}')`}"/>
		</div>
		<div class="date" v-text="date"/>
		<div class="title" v-text="title"/>
		<div class="content">
			<vHtml v-bind="{markdown: content}"/>
		</div>
	</div>
</template>

<script>
import {date} from "@/modules/utils";
import vHtml from "@/components/html.vue";

export default {
	components: {vHtml},
	props: {
		title: {type: String, required: true},
		image: {type: Object, required: false},
		content: {type: String, required: true},
		published_at: {type: Number, required: true}
	},
	computed: {
		imageUrl: (t) => t.image ? t.image.url : null,
		date() {
			const d = date(this.published_at);
			return `${d.day}-${d.month}-${d.year}`;
		}
	}
};
</script>

<style lang="scss" scoped>
.item {
	.image {
		margin-bottom: 34px;

		.img {
			background-color: #ededed;
			background-repeat: no-repeat;
			background-position: center;
			background-size: cover;
			width: 100%;
			padding-bottom: 50%;
		}
	}

	.date {
		font-size: 12px;
		color: #303C49;
		opacity: 0.4;
		font-weight: 500;
		letter-spacing: 1px;
		margin-bottom: 15px;
	}

	.title {
		font-size: 21px;
		font-weight: 500;
	}

	.content {
		padding-bottom: 60px;
		margin-bottom: 50px;
		border-bottom: 1px solid #F4F6F8;
	}
}
</style>
